// 追加メッセージのtype
export type ListAddMessage = {
    mp_id: number;
    addMessage: string;
};

export type SuggestItems = {
    mp_id?: number;
    maker_name: string;
    mp_product_name: string;
    mp_product_name_search: string;
    mp_model_number1: string;
    mp_model_number1_search: string;
    model_flg: number;
};

export const SUGGEST_ITEMS_INIT: SuggestItems = {
    mp_id: 1,
    maker_name: '',
    mp_product_name: '',
    mp_product_name_search: '',
    mp_model_number1: '',
    mp_model_number1_search: '',
    model_flg: 0,
};
